import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import HeaderComponent from "./components/header/Header.Component";
import { ROUTES } from "./routes";
import LoginScreen from "./screens/Login.Screen";
import MainScreen from "./screens/Main.Screen";
import "./App.scss";
import FirebaseContext from "./contexts/FirebaseContext";
import TeamsScreen from "./screens/Teams.Screen";
import UserScreen from "./screens/User.Screen";
import MyTeamScreen from "./screens/MyTeam.Screen";
import ManageScreen from "./screens/Manage.Screen";

import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import "@blueprintjs/popover2/lib/css/blueprint-popover2.css";
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";

function App() {
  const location = useLocation();

  return (
    <div className="App bp3-dark">
      {location.pathname.split("/")[1] !== "login" ? (
        <HeaderComponent />
      ) : (
        <></>
      )}
      <FirebaseContext>
        <Switch>
          <Route exact path={ROUTES.mainScreen} component={MainScreen} />
          <Route exact path={ROUTES.loginScreen} component={LoginScreen} />
          <Route exact path={ROUTES.teamsScreen} component={TeamsScreen} />
          <Route path={ROUTES.userScreen} component={UserScreen} />
          <Route path={ROUTES.myTeam} component={MyTeamScreen} />
          <Route path={ROUTES.manageScreen} component={ManageScreen} />
        </Switch>
      </FirebaseContext>
    </div>
  );
}

export default App;
